import React, { useState } from "react";

import Text from "src/components/text"
import DeleteDataSource from "../deleteDataSource";

import { getStorageDetails, StorageType } from "src/utils/dataSource.helper";
import { formatDate } from "src/utils/helper";

import cx from "classnames";
import styles from "./styles.module.scss";

interface DataSourceCardProps {
  type: StorageType;
  header: string;
  status?: React.ReactNode;
  migrationStatus?: string;
  children?: React.ReactNode;
  item?: any;
}

const EXCLUDED_STORAGE_TYPES =[
  "e2open_brand_folder",
];

const DataSourceCard: React.FC<DataSourceCardProps> = ({
  type,
  header,
  status,
  migrationStatus,
  children,
  item
}) => {

  const { image, name } = getStorageDetails(
  EXCLUDED_STORAGE_TYPES.includes(item.storageType) ? StorageType.BRANDFOLDER : type
) || {};
  const [showDelete, setShowDelete] = useState(false);

  const hasMigrationDate = !!item.lastMigrationDate;
  const label = hasMigrationDate ? "Last migrated on" : "Last updated on";
  const date = hasMigrationDate ? item.lastMigrationDate : item.modifiedDate;  

  return (
    <div
      className={cx(
        styles.card,
        migrationStatus === "AUTH_ERROR" && styles.authenticateCard,
        EXCLUDED_STORAGE_TYPES.includes(item.storageType) && styles.excludedCard
      )}
    >
      <div className={styles.headerWrapper}>
        <Text text={header} className={styles.header} lines={1} />
        <div className={styles.iconWrapper}>
          {image && <img src={image} alt={name} className={styles.icon} />}
         
            <i className={cx(
              "paperflite-delete",
              styles.deleteIcon,
            )}
              onClick={() => setShowDelete(true)} />
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.subtextWrapper}>
          <div>{item.assets} Assets</div>
          <div>
            {label} {formatDate(date)}
          </div>
        </div>
        {status && type !== 'rss' && (
          <div className={styles.status}>{status}</div>
        )}
        {children && <div className={styles.children}>{children}</div>}
        <DeleteDataSource
          item={item}
          show={showDelete}
          onClose={() => setShowDelete(false)}
          label={label}
          date={date}
        />
      </div>
    </div>
  );
};

export default DataSourceCard;
